<script setup>
import LoginForm from "@/forms/LoginForm.vue";

definePage({
    meta: {
        layout: 'guest'
    }
})
</script>

<template>
    <login-form />
</template>
